export const Users = [
  {
    id: 1,
    profilePicture: "assets/person/1.jpg",
    username: "Elon Musk",
  },
  {
    id: 2,
    profilePicture: "assets/person/2.jpg",
    username: "Bernard Arnault",
  },
  {
    id: 3,
    profilePicture: "assets/person/3.jpg",
    username: "Jeff Bezos",
  },
  {
    id: 4,
    profilePicture: "assets/person/4.jpg",
    username: "Gautam Adani",
  },
  {
    id: 5,
    profilePicture: "assets/person/5.jpg",
    username: "Bill Gates",
  },
  {
    id: 6,
    profilePicture: "assets/person/6.jpg",
    username: "Warren Buffett",
  },
  {
    id: 7,
    profilePicture: "assets/person/7.jpg",
    username: "Larry Ellison",
  },
  {
    id: 8,
    profilePicture: "assets/person/8.jpg",
    username: "Mukesh Ambani",
  },
  {
    id: 9,
    profilePicture: "assets/person/9.jpg",
    username: "Larry Page",
  },
  {
    id: 10,
    profilePicture: "assets/person/10.jpg",
    username: "Sergey Brin",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "I operate on the physics approach to analysis. You boil things down to the first principles or fundamental truths in a particular area and then you reason up from there.",
    photo: "assets/post/1.jpg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    photo: "assets/post/2.jpg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "I didn't think I'd regret trying and failing. And I suspected I would always be haunted by a decision to not try at all.",
    photo: "assets/post/3.jpg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    photo: "assets/post/4.jpg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  {
    id: 5,
    photo: "assets/post/5.jpg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 5,
  },
  {
    id: 6,
    photo: "assets/post/6.jpg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  },
  {
    id: 7,
    desc: "When people start telling you that you're crazy, you just might be on to the most important innovation in your life.",
    photo: "assets/post/7.jpg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 3,
  },
  {
    id: 8,
    photo: "assets/post/8.jpg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 1,
  },
  {
    id: 9,
    desc: "You never lose a dream; it just incubates as a hobby.",
    photo: "assets/post/9.jpg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 10,
    photo: "assets/post/10.jpg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
];
